export const environment = {
    production: true,
    apiUrl: '/relay-api/',
    loginUrl: '/relay-api/authentication/okta/login'
};
